import { render } from "./PrivacyPolicyModal.vue?vue&type=template&id=444a4607&scoped=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=js"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=444a4607&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444a4607"]])

export default __exports__